import { createApp } from 'vue';
import { createPinia } from 'pinia'
import App from './App.vue';
import'./index.css';
import router from './Router/index';
// const app = createApp({});

  const initializeApp = async () => {
    try {
      console.log('Initializing app...');

      const { default: axios } = await import('axios');
  
      console.log('App, router, and axios imported successfully.');
  
      axios.interceptors.request.use((config) => {
        const token = localStorage.getItem('token');
    
        if (token && !Object.prototype.hasOwnProperty.call(config.headers, 'Authorization')) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
    
        return config;
      }, (error) => {
        return Promise.reject(error);
      });

          // ✅ Response Interceptor to handle 401
      axios.interceptors.response.use(
        response => response,
        error => {
          if (error.response && error.response.status === 401) {
            console.warn('401 detected. Logging out...');
            localStorage.clear(); // Clear user data
            router.push('/login'); // Redirect to login page
          }
          return Promise.reject(error);
        }
      );
    
  
      console.log('Axios interceptor configured successfully.');  
      const app = createApp(App);
      const pinia = createPinia();
      app.use(pinia);
      app.use(router);
      app.mount('#app');      
  
      console.log('App initialized successfully.');
    } catch (error) {
      console.error('Error initializing app:', error);
    }
  };
  initializeApp();
// createApp(App).use(router).mount('#app')
